import { Navigate } from 'react-router-dom'
import type { RouteFactory } from '../types'

/**
 * Creates top-level redirect routes for legacy and deprecated paths.
 * These redirects handle URL migrations and ensure backwards compatibility.
 */
export const createRedirectRoutes: RouteFactory = () => [
  /**
   * /dashboard/chat → /dashboard
   * Bare chat path redirects to dashboard home.
   */
  {
    path: '/dashboard/chat',
    element: <Navigate to="/dashboard" replace />,
  },

  /**
   * /dashboard/laws-regulations → /dashboard/matters
   * Legacy laws-regulations feature redirect (LRR deprecated).
   */
  {
    path: '/dashboard/laws-regulations',
    element: <Navigate to="/dashboard/matters" replace />,
  },

  /**
   * /dashboard/case-law → /dashboard/matters
   * Legacy case-law feature redirect (caselaw deprecated).
   */
  {
    path: '/dashboard/case-law',
    element: <Navigate to="/dashboard/matters" replace />,
  },

  /**
   * /dashboard/chat/sec → /dashboard
   * Deprecated SEC chat feature redirect.
   */
  {
    path: '/dashboard/chat/sec',
    element: <Navigate to="/dashboard" replace />,
  },

  // Note: /dashboard/files and /dashboard/drives redirects are handled by legacyRedirects.tsx

  /**
   * /dashboard/examples → /dashboard
   * Deprecated examples page redirect.
   */
  {
    path: '/dashboard/examples',
    element: <Navigate to="/dashboard" replace />,
  },

  /**
   * /dashboard/guides → /dashboard
   * Deprecated guides page redirect.
   */
  {
    path: '/dashboard/guides',
    element: <Navigate to="/dashboard" replace />,
  },
]
